import ThemeButton from "components/Buttons/ThemeButton";
import { styled } from "@mui/material";

export const Container = styled("div")<{ background: string; scale: number }>`
	width: 343px;
	height: 608px;
	border-radius: 1rem;
	background-image: url(${(props) => props.background});
	background-repeat: no-repeat;
	background-size: 100%;
	background-position: center;
	padding: 2rem 1rem;
	background-color: #0184a4;
	position: relative;
	text-align: center;
	overflow: hidden;
	transform: scale(${(props) => props?.scale});

	.sub-container {
		display: flex;
		flex-direction: column;
		align-items: center;
		text-align: center;
		gap: 1rem;
	}

	@media (min-width: 600px) {
		width: 845px;
		height: 260px;
		background-position: center;

		.sub-container {
			gap: 0.5rem;
		}
	}
`;

export const Title = styled("h1")<{ isError?: boolean }>`
	color: #113b62;
	font-family: "Baloo";
	font-size: 47px;
	line-height: 44px;
	margin: 0;
	text-shadow: 0px 5px 6px rgba(0, 0, 0, 0.15);
	-webkit-text-stroke-width: 5px;
	-webkit-text-stroke-color: #fff;
	paint-order: stroke fill;

	@media (min-width: 600px) {
		font-size: 43px;
		line-height: 40px;
	}
`;

export const Description = styled("p")<{ isError?: boolean }>`
	text-shadow: 1.08px 1.08px 0px #000;
	-webkit-text-stroke-width: 1.08px;
	-webkit-text-stroke-color: #000;
	paint-order: stroke fill;
	font-family: "Baloo";
	line-height: 115%;
	font-size: 25px;
	max-width: 80%;
	color: white;
	margin: 0;

	& span {
		color: #fbbd05;
	}

	@media (min-width: 600px) {
		font-size: 18px;
	}
`;

export const RewardNumber = styled(Description)<{ ammount?: string }>`
	font-size: 42px;
	position: absolute;
	bottom: 0;
	right: ${(props) => (Number(props.ammount?.length) > 3 ? "50%" : "18px")};
	transform: ${(props) =>
		Number(props.ammount?.length) > 3 ? "translateX(50%)" : "none"};

	@media (min-width: 600px) {
		font-size: 22px;
		bottom: 3px;
	}
`;

export const Button = styled(ThemeButton)`
	width: 40%;
`;

export const RewardContainer = styled("div")`
	position: relative;
	background: rgba(0, 0, 0, 0.25);
	border-radius: 1rem;
	width: 112px;
	height: 112px;
	padding: 24px;
	display: flex;
	align-items: center;
	justify-content: center;

	@media (min-width: 600px) {
		width: 69px;
		height: 69px;
		padding: 10px;
	}
`;
